// releasesApi.js — System-wide release notes (SystemAdmin authoring + user viewing).
// Auth header is attached globally by BootNav (axios.defaults), but we also
// attach it explicitly so these helpers work before BootNav has mounted
// (e.g. the first-login modal check).
import axios from "axios";

const URL =
  process.env.REACT_APP_API_BASE_PROD_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:3002";

function authHeader() {
  const token = sessionStorage.getItem("user");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/* ---- SystemAdmin authoring ---- */

export async function getReleases() {
  const response = await axios.get(`${URL}/api/releases`, { headers: authHeader() });
  return response.data;
}

export async function createRelease({ name, description }) {
  const response = await axios.post(
    `${URL}/api/releases`,
    { name, description },
    { headers: authHeader() }
  );
  return response.data;
}

export async function updateRelease(releaseId, { name, description }) {
  const response = await axios.put(
    `${URL}/api/releases/${releaseId}`,
    { name, description },
    { headers: authHeader() }
  );
  return response.data;
}

export async function publishRelease(releaseId) {
  const response = await axios.patch(
    `${URL}/api/releases/${releaseId}/status`,
    { status: "Released" },
    { headers: authHeader() }
  );
  return response.data;
}

export async function deleteRelease(releaseId) {
  const response = await axios.delete(`${URL}/api/releases/${releaseId}`, {
    headers: authHeader(),
  });
  return response.data;
}

export async function uploadReleaseVideo(releaseId, file, title, onUploadProgress) {
  const formData = new FormData();
  formData.append("video", file);
  formData.append("title", title || "");
  const response = await axios.post(
    `${URL}/api/releases/${releaseId}/videos`,
    formData,
    { headers: authHeader(), onUploadProgress }
  );
  return response.data;
}

export async function deleteReleaseVideo(releaseId, blobName) {
  const response = await axios.delete(
    `${URL}/api/releases/${releaseId}/videos/${encodeURIComponent(blobName)}`,
    { headers: authHeader() }
  );
  return response.data;
}

/* ---- All users ---- */

export async function getReleasedReleases() {
  const response = await axios.get(`${URL}/api/releases/released`, {
    headers: authHeader(),
  });
  return response.data;
}

export async function getLatestRelease() {
  const response = await axios.get(`${URL}/api/releases/latest`, {
    headers: authHeader(),
  });
  return response.data;
}

// Marks the release notes as seen and returns { success, token } — the fresh
// JWT must replace sessionStorage "user" so the modal stays suppressed.
export async function markReleaseSeen() {
  const response = await axios.post(
    `${URL}/api/releases/seen`,
    {},
    { headers: authHeader() }
  );
  return response.data;
}
